var _circle, _path, _circle2, _circle3, _ellipse, _circle4, _circle5, _ellipse2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroceryStoreCart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#FDE5C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7649 21.9689C12.4405 21.6301 11.935 21.5387 11.5125 21.7423L10.8596 22.0568C10.2494 22.3508 10.0558 23.1264 10.4561 23.6728L18.5388 34.7036C18.6501 34.8554 18.7198 35.0335 18.7412 35.2205L21.1817 56.5081C21.2431 57.0445 21.6972 57.4494 22.237 57.4494C22.8237 57.4494 23.2993 57.925 23.2993 58.5117V64.1035C23.2993 64.7017 23.7842 65.1866 24.3824 65.1866H25.0297C25.6279 65.1866 26.1128 64.7017 26.1128 64.1035V58.5325C26.1128 57.9343 26.5977 57.4494 27.1959 57.4494H63.0125C63.6107 57.4494 64.0956 57.9343 64.0956 58.5325V64.1035C64.0956 64.7017 64.5806 65.1866 65.1788 65.1866H65.8261C66.4243 65.1866 66.9092 64.7017 66.9092 64.1035V57.8985C66.9092 57.6505 67.1103 57.4494 67.3583 57.4494C67.5422 57.4494 67.7075 57.3373 67.7755 57.1664L78.4097 30.4459C78.6927 29.7347 78.1688 28.9623 77.4033 28.9623H19.9245C19.6291 28.9623 19.3465 28.8416 19.1422 28.6283L12.7649 21.9689ZM21.3411 33.0605C21.2604 32.4141 21.7645 31.8431 22.4159 31.8431H72.7323C73.4884 31.8431 74.0119 32.5982 73.7466 33.3063L72.3434 37.0515C72.185 37.4744 71.7808 37.7546 71.3292 37.7546H22.8836C22.3373 37.7546 21.8766 37.3478 21.8089 36.8057L21.3411 33.0605ZM22.4307 41.7855C22.35 41.1391 22.8541 40.5681 23.5055 40.5681H69.4636C70.2196 40.5681 70.7431 41.3232 70.4778 42.0312L69.1813 45.4921C69.0228 45.915 68.6186 46.1952 68.167 46.1952H23.9377C23.3914 46.1952 22.9306 45.7884 22.8629 45.2463L22.4307 41.7855ZM24.5832 49.0088C23.9235 49.0088 23.417 49.5935 23.5111 50.2464L23.9732 53.4521C24.05 53.9851 24.5068 54.3807 25.0453 54.3807H64.8294C65.2614 54.3807 65.6521 54.124 65.8235 53.7275L67.2096 50.5218C67.5188 49.8067 66.9945 49.0088 66.2155 49.0088H24.5832Z",
    fill: "#818A98"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0576,
    cy: 65.1867,
    r: 5.97878,
    fill: "#505862"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0572,
    cy: 65.1867,
    r: 4.22031,
    fill: "#B9BEC6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0574,
    cy: 65.1868,
    rx: 2.81354,
    ry: 2.81354,
    fill: "#505862"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5025,
    cy: 65.1867,
    r: 5.97878,
    fill: "#505862"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5018,
    cy: 65.1867,
    r: 4.22031,
    fill: "#B9BEC6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.502,
    cy: 65.1868,
    rx: 2.81354,
    ry: 2.81354,
    fill: "#505862"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24.2474,
    width: 9.25953,
    height: 6.19012,
    rx: 2.64045,
    transform: "rotate(-34.5211 7 24.2474)",
    fill: "#EA7362"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroceryStoreCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GroceryStoreCart.b083e1bca56f3eca5c21648a562bab23.svg";